import Swiper from "swiper/bundle";

export default class Slider {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const option = {
            loop: true,
            pagination: { el: ".swiper-pagination", clickable: true },
        };

        const swiper = new Swiper(".bddvd__tokuten__modal__cont", option);
        const swiper2 = new Swiper(".bddvd__content__slider", option);
    }
}
